var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        placement: "bottom-end",
        trigger: "hover",
        disabled: _vm.disabled,
      },
    },
    [
      _vm._l(_vm.menu.children, function (dict) {
        return _c(
          "div",
          {
            key: dict.name,
            staticClass: "directory",
            staticStyle: { "max-width": "420px" },
          },
          [
            dict.children
              ? [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "menu::" +
                              dict["actionCode"].split("::").slice(1).join("::")
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "menuList" },
                    _vm._l(dict.children, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.actionCode,
                          staticClass: "menu",
                          class: dict.name.split("::").slice(0),
                          on: {
                            click: function ($event) {
                              return _vm.toUrl(item)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "iconfont",
                            class: item.icon,
                          }),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "menu::" +
                                      item["actionCode"]
                                        .split("::")
                                        .slice(1)
                                        .join("::")
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
      _c(
        "el-link",
        {
          staticClass: "dict",
          attrs: { slot: "reference", underline: false },
          slot: "reference",
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  _vm.menu.actionCode
                    ? "menu::" +
                        _vm.menu["actionCode"].split("::").slice(1).join("::")
                    : ""
                )
              ) +
              " "
          ),
          _c("i", { staticClass: "iconfont icondown-circle-01" }),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }